import React from 'react';

import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet-async';
import { getTitle as getPageTitle, PageDetails } from '../models/page';

interface TMetaProps {
  pageDetails: PageDetails;
}

export const MetaTermsAndConditions = ({
  pageDetails,
}: TMetaProps): React.ReactElement => {
  const { formatMessage } = useIntl();
  const shortTitle = formatMessage({
    id: 'LEGAL_PAGES_TERMS_AND_CONDITIONS_SHORT_TITLE',
  });
  const description = formatMessage({
    id: 'LEGAL_PAGES_TERMS_AND_CONDITIONS_PAGE_META_DESCRIPTION',
  });

  return (
    <>
      <Helmet>
        <title>{`${pageDetails.name}: ${shortTitle} | XING`}</title>
        <meta
          name="og:title"
          content={`${pageDetails.name}: ${shortTitle} | XING`}
        />
      </Helmet>
      <Helmet>
        <meta
          name="description"
          content={`${getPageTitle(pageDetails)}${description}`}
        />
        <meta
          name="og:description"
          content={`${getPageTitle(pageDetails)}${description}`}
        />
      </Helmet>
    </>
  );
};

export const MetaLegalPages = ({
  pageDetails,
}: TMetaProps): React.ReactElement => {
  return (
    <>
      <Helmet>
        <title>{`${pageDetails.name} | XING`}</title>
        <meta name="og:title" content={`${pageDetails.name} | XING`} />
      </Helmet>
      <Helmet>
        <meta name="description" content={`${getPageTitle(pageDetails)}`} />
        <meta name="og:description" content={`${getPageTitle(pageDetails)}`} />
      </Helmet>
    </>
  );
};
